import { useCallback, useEffect, useRef, useState } from 'react';
import submittalsService from '@/services/api/submittalsService.js';

const PAGE_SIZE = 10;

const useSubmittals = (isEnabled, { page, search, sort, order, filters } = {}) => {
	const [submittals, setSubmittals] = useState([]);
	const [meta, setMeta] = useState({ total: 0, totalPages: 1 });
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const requestIdRef = useRef(0);

	const fetchSubmittals = useCallback(() => {
		if (!isEnabled) return;
		setLoading(true);
		setError(null);

		const params = {
			page: page || 1,
			page_size: PAGE_SIZE,
			payload_fields_to_extract: ['project_details'],
		};
		if (search) params.search = search;
		if (sort) params.sort = sort;
		if (order) params.order = order;
		if (filters?.data_element_id) params.data_element_id = filters.data_element_id;
		if (filters?.submission_month) params.submission_month = filters.submission_month;
		if (filters?.status) params.status = filters.status;
		if (filters?.project_contract_number) params.project_contract_number = filters.project_contract_number;

		const currentRequestId = ++requestIdRef.current;

		submittalsService.getSubmittals(params)
			.then(([err, response]) => {
				if (currentRequestId !== requestIdRef.current) return;
				setLoading(false);
				if (err) {
					setError('Failed to load submittals.');
					return;
				}
				setSubmittals(response?.items || []);
				setMeta({
					total: response?.meta?.total || 0,
					totalPages: response?.meta?.total_pages || 1,
				});
			})
			.catch(() => {
				if (currentRequestId !== requestIdRef.current) return;
				setLoading(false);
				setError('Failed to load submittals.');
			});
	}, [isEnabled, page, search, sort, order,
		filters?.data_element_id, filters?.submission_month,
		filters?.status, filters?.project_contract_number]);

	useEffect(() => {
		fetchSubmittals();
	}, [fetchSubmittals]);

	return { submittals, meta, loading, error, refetch: fetchSubmittals };
};

export default useSubmittals;
